import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const ArrowForwardThin: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='15'
      viewBox='0 0 28 15'
      fill='none'
    >
      <path
        d='M26.8503 1.00012L13.9999 13.8505'
        strokeWidth='2'
        strokeLinecap='round'
        stroke='currentColor'
      />
      <path
        d='M13.8504 13.8504L0.999992 0.99999'
        strokeWidth='2'
        stroke='currentColor'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default ArrowForwardThin;
